import type { Technology } from 'domain/shared/career';
import type { PositionType } from 'domain/shared/employee';

type PositionProfileLabelSource = {
  specializationId: number;
  technologyId: string | null;
};

export type PositionProfileLabels = {
  specializationLabel: string;
  technologyLabel: string | null;
};

export const createPositionProfileLabelsResolver = (
  positions: PositionType[],
  technologies: Technology[],
): ((profile: PositionProfileLabelSource) => PositionProfileLabels) => {
  const positionNames = new Map(positions.map(position => [position.id, position.name]));
  const technologyNames = new Map(technologies.map(technology => [technology.id, technology.name]));

  return profile => ({
    specializationLabel: positionNames.get(Number(profile.specializationId)) ?? String(profile.specializationId),
    technologyLabel: profile.technologyId ? (technologyNames.get(profile.technologyId) ?? profile.technologyId) : null,
  });
};
